export const TeamAssemblyIcon = () => (
  <svg
    width="93"
    height="103"
    viewBox="0 0 93 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="21.042"
      cy="66.5688"
      r="10.4526"
      stroke="#6087AB"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle
      cx="71.1472"
      cy="66.5688"
      r="10.4526"
      stroke="#6087AB"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle
      cx="46.0949"
      cy="13.6"
      r="12.6"
      stroke="#6087AB"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M21.0424 52.6108C21.0424 49.8379 21.6904 47.0921 22.9494 44.5302C24.2084 41.9683 26.0538 39.6405 28.3802 37.6797C30.7065 35.7189 33.4683 34.1635 36.5078 33.1024C39.5474 32.0412 42.8051 31.495 46.0951 31.495C49.385 31.495 52.6428 32.0412 55.6823 33.1024C58.7218 34.1636 61.4836 35.7189 63.81 37.6797C66.1363 39.6405 67.9817 41.9683 69.2407 44.5302C70.4997 47.0921 71.1477 49.8379 71.1477 52.6108"
      stroke="#6087AB"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M0.999987 102C0.999987 99.2275 1.51839 96.4817 2.5256 93.9198C3.53282 91.3579 5.00911 89.0301 6.87019 87.0694C8.73127 85.1086 10.9407 83.5532 13.3723 82.492C15.8039 81.4309 18.4101 80.8847 21.0421 80.8847C23.6741 80.8847 26.2803 81.4309 28.7119 82.492C31.1435 83.5532 33.3529 85.1086 35.214 87.0694C37.0751 89.0301 38.5514 91.3579 39.5586 93.9198C40.5658 96.4817 41.0842 99.2275 41.0842 102"
      stroke="#6087AB"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M51.1057 102C51.1057 99.2275 51.6241 96.4817 52.6313 93.9198C53.6385 91.3579 55.1148 89.0301 56.9759 87.0694C58.837 85.1086 61.0464 83.5532 63.478 82.492C65.9097 81.4309 68.5159 80.8847 71.1478 80.8847C73.7798 80.8847 76.386 81.4309 78.8176 82.492C81.2492 83.5532 83.4587 85.1086 85.3197 87.0694C87.1808 89.0301 88.6571 91.3579 89.6643 93.9198C90.6715 96.4817 91.1899 99.2275 91.1899 102"
      stroke="#6087AB"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);
